var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 19.125C4.35 19.125 4.14583 19.0458 3.9875 18.8875C3.82917 18.7291 3.75 18.525 3.75 18.275C3.75 18.025 3.82917 17.8208 3.9875 17.6625C4.14583 17.5041 4.35 17.425 4.6 17.425H5.9V9.94995C5.9 8.53328 6.32083 7.25412 7.1625 6.11245C8.00417 4.97078 9.11667 4.24995 10.5 3.94995V3.24995C10.5 2.84995 10.6458 2.51245 10.9375 2.23745C11.2292 1.96245 11.5833 1.82495 12 1.82495C12.4167 1.82495 12.7708 1.96245 13.0625 2.23745C13.3542 2.51245 13.5 2.84995 13.5 3.24995V3.94995C14.8833 4.24995 16 4.97078 16.85 6.11245C17.7 7.25412 18.125 8.53328 18.125 9.94995V17.425H19.4C19.65 17.425 19.8583 17.5083 20.025 17.675C20.1917 17.8416 20.275 18.0416 20.275 18.275C20.275 18.525 20.1917 18.7291 20.025 18.8875C19.8583 19.0458 19.65 19.125 19.4 19.125H4.6ZM12 22.15C11.45 22.15 10.9708 21.9499 10.5625 21.5499C10.1542 21.15 9.95 20.6666 9.95 20.1H14.05C14.05 20.6666 13.85 21.15 13.45 21.5499C13.05 21.9499 12.5667 22.15 12 22.15ZM7.6 17.425H16.425V9.94995C16.425 8.69995 16.0042 7.64578 15.1625 6.78745C14.3208 5.92912 13.2833 5.49995 12.05 5.49995C10.8 5.49995 9.74583 5.92912 8.8875 6.78745C8.02917 7.64578 7.6 8.69995 7.6 9.94995V17.425Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1a4ca1c0.svg";
export { ForwardRef as ReactComponent };